<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs
        headline="Báo cáo tiến độ khai KHGD"
        :link="[{ text: 'Báo cáo tiến độ khai KHGD', href: '../teaching-plan-progress-report' }]"
      />
    </div>

    <div v-for="level in academicLevelOptions" :key="level.id">
      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
        <div class="mb-4 font-weight-bold" style="color: #255cc2; text-transform: uppercase; font-size: 18px;">
          Tiến độ khai KHGD theo Khối {{ level.title }}
        </div>
        <TeachingPlanProgressChart :academicLevelId="level.id" />
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import TeachingPlanProgressChart from '@/modules/teachingPlan/TeachingPlanProgressChart.vue'

export default {
  components: {
    Breadcrumbs,
    TeachingPlanProgressChart,
  },
  data() {
    return {
      academicLevelOptions: [],
    }
  },
  computed: {
    ...mapState('AcademicLevel', ['academics']),
  },
  methods: {
    ...mapActions('AcademicLevel', ['fetchAcademics']),
    async fetchAcademicLevels() {
      await this.fetchAcademics({ status: 'active' })
      this.academicLevelOptions = this.academics || []
    },
  },
  mounted() {
    this.fetchAcademicLevels()
  },
}
</script>
